export { _clearMessageStore as clearMessageStore };
export { _getMessageItem as getMessageItem };

const DB_NAME = "firebase-messaging-database";
const STORE_NAME = "firebase-messaging-store";

const _clearMessageStore = () => {
  return new Promise(function (resolve, reject) {
    const dbRequest = window.indexedDB.open(DB_NAME);

    dbRequest.onerror = function (event) {
      reject(Error("Error text"));
    };

    dbRequest.onupgradeneeded = function (event) {
      // Objectstore does not exist. Nothing to load
      event.target.transaction.abort();
      reject(Error("Not found"));
    };

    dbRequest.onsuccess = function (event) {
      const database = event.target.result;
      const transaction = database.transaction([STORE_NAME], "readwrite");
      const objectStore = transaction.objectStore(STORE_NAME);
      const objectRequest = objectStore.clear();

      objectRequest.onerror = function (event) {
        reject(Error("Error text"));
      };

      objectRequest.onsuccess = function (event) {
        console.log("Firebase messaging store cleared");
        resolve();
      };
    };
  });
};

const _getMessageItem = () => {
  return new Promise(function (resolve, reject) {
    const dbRequest = window.indexedDB.open(DB_NAME);

    dbRequest.onerror = function (event) {
      reject(Error("Error text"));
    };

    dbRequest.onupgradeneeded = function (event) {
      // Objectstore does not exist. Nothing to load
      event.target.transaction.abort();
      reject(Error("Not found"));
    };

    dbRequest.onsuccess = function (event) {
      const database = event.target.result;
      const transaction = database.transaction([STORE_NAME]);
      const objectStore = transaction.objectStore(STORE_NAME);
      const objectRequest = objectStore.getAll();

      objectRequest.onerror = function (event) {
        reject(Error("Error text"));
      };

      objectRequest.onsuccess = function (event) {
        if (
          objectRequest.result &&
          Array.isArray(objectRequest.result) &&
          objectRequest.result.length
        ) {
          const tokens = objectRequest.result.map((obj) => {
            return {
              token: obj.token,
              created: obj.createTime
                ? new Date(obj.createTime).toISOString()
                : null,
            };
          });
          resolve(tokens);
        } else {
          reject(Error("Object not found or not an array"));
        }
      };
    };
  });
};
